import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { OrgRoleItemResponse, ProductClaim } from '~/Services/RoleServices'

export interface OrganizationRoleFilter {
  queryString?: string
  columnFilters?: Record<string, any>
}

export interface OrganizationRoleReducerStore {
  currentRole: OrgRoleItemResponse | null
  currentRoleClaims: ProductClaim[]
  loading: boolean
  claimsLoading: boolean
  error: string | null
  keyword: string
}

const initialState: OrganizationRoleReducerStore = {
  currentRole: null,
  currentRoleClaims: [],
  loading: false,
  claimsLoading: false,
  error: null,
  keyword: '',
}

export const OrganizationRoleSlice = createSlice({
  name: 'organizationRoles',
  initialState,
  reducers: {
    // Get product claims of role
    getProductClaimsOfRole: (
      state,
      action: PayloadAction<{
        clientId: string
        roleId: string
        onSuccess?: (claims: ProductClaim[]) => void
        onFailure?: (error: string) => void
      }>,
    ) => {
      state.claimsLoading = true
      state.error = null
    },
    getProductClaimsOfRoleSuccess: (
      state,
      action: PayloadAction<ProductClaim[]>,
    ) => {
      state.currentRoleClaims = action.payload
      state.claimsLoading = false
      state.error = null
    },
    getProductClaimsOfRoleFail: (state, action: PayloadAction<string>) => {
      state.claimsLoading = false
      state.error = action.payload
    },

    // Update product claims
    updateProductClaims: (
      state,
      action: PayloadAction<{
        clientId: string
        roleId: string
        productClaims: ProductClaim[]
        onSuccess?: () => void
        onFailure?: (error: string) => void
      }>,
    ) => {
      state.claimsLoading = true
      state.error = null
    },
    updateProductClaimsSuccess: state => {
      state.claimsLoading = false
      state.error = null
    },
    updateProductClaimsFail: (state, action: PayloadAction<string>) => {
      state.claimsLoading = false
      state.error = action.payload
    },

    // Clear current role claims
    clearCurrentRoleClaims: state => {
      state.currentRoleClaims = []
    },

    setKeyword: (state, action: PayloadAction<string>) => {
      state.keyword = action.payload
    },

    // Clear error
    clearError: state => {
      state.error = null
    },
  },
})

export const OrganizationRoleActions = OrganizationRoleSlice.actions
export const OrganizationRoleReducer = OrganizationRoleSlice.reducer
